import { render, staticRenderFns } from "./AppSeparator.vue?vue&type=template&id=313baf6e&"
import script from "./AppSeparator.vue?vue&type=script&lang=js&"
export * from "./AppSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports